import { useState, useEffect } from "react";

import { isValidEmail } from "@usas/ui-web/utils/validation";

const useUserInfoForm = (onSubmitFormCallback, userInfoData, childData, isUserUnder16 = false) => {
  const [formState, setFormState] = useState({
    firstName: userInfoData?.firstName || childData?.firstName || '',
    preferredName: userInfoData?.preferredName || childData?.preferredName || '',
    middleName: userInfoData?.middleName || childData?.middleName || '',
    lastName: userInfoData?.lastName || childData?.lastName || '',
    email: userInfoData?.email || '',
    phoneNumber: userInfoData?.phoneNumber || '',
    memberId: userInfoData?.memberId || childData?.memberId || ''
  });

  const [errorState, setErrorState] = useState({
    firstName: '',
    preferredName: '',
    middleName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    memberId: ''
  });

  const updateFormState = (field, value) => {
    setFormState(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear error when user starts typing
    if (errorState[field]) {
      setErrorState(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const onEmailChanged = (value) => {
    updateFormState('email', value);
  };

  const validateForm = () => {
    const errors = {};

    // Required field validation
    if (!formState.firstName?.trim()) {
      errors.firstName = 'First name is required';
    }

    if (!formState.lastName?.trim()) {
      errors.lastName = 'Last name is required';
    }

    // Only validate email if user is 16+ (when email field is visible)
    if (!isUserUnder16) {
      if (!formState.email?.trim()) {
        errors.email = 'Email is required';
      } else if (!isValidEmail(formState.email.trim())) {
        errors.email = 'Please enter a valid email address';
      }
    }

    // Member ID validation (if provided)
    if (formState.memberId?.trim()) {
      // Add any member ID specific validation here if needed
    }

    setErrorState(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm() && onSubmitFormCallback) {
      onSubmitFormCallback(formState);
    }
  };

  return {
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    onEmailChanged
  };
};

export default useUserInfoForm;